//获取当前域名
/**
  @method getDomain
  @param url 相对、全路径，根路径(/content/index.html#/dict/table/edit)
  @return url 全路径(http://sccdev.cd.pangu16.com/content/index.html#/dict/table/edit)
  prefix 只在url中没有http或者https并且prefix有值时才会当做前缀加在url前面
*/
export function getDomain(url, prefix) {
  if (url && url.indexOf('http://') == -1 && url.indexOf('https://') == -1) {
    if (prefix) {
      return prefix + url
    }
    return window.location.protocol + '//' + window.location.host + url
  }
  return url
}

//获取当前域名
/**
  @method getDomain
  @param url 相对、全路径，根路径(/content/index.html#/dict/table/edit)
  @return url 全路径(http://sccdev.cd.pangu16.com/content/index.html#/dict/table/edit)
  prefix 只在url中没有http或者https并且prefix有值时才会当做前缀加在url前面
*/
export function getDomainByHostname(url, prefix) {
  if (url && url.indexOf('http://') == -1 && url.indexOf('https://') == -1) {
    if (prefix) {
      return prefix + url
    }
    return window.location.protocol + '//' + window.location.hostname + url
  }
  return url
}

/**
 * 获取静态资源路径
 * @example
 * src: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/build/pdf.worker.min.js'
   src: '/static/pdf/2.0.943/build/pdf.worker.js'
   src: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.min.js'
   src: '/static/pdf/2.6.347/build/pdf.worker.min.js'
   或者
   cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/cmaps/',
   cMapUrl: '/static/pdf/2.0.943/cmaps/',
   cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/cmaps/',
   cMapUrl: '/static/pdf/2.6.347/cmaps/'
 * 
 * @param {String} src 
 * @returns 
 */
export function getSrc(src) {
  const url = window.location.href

  if (/\/link\//.test(url)) return '/link' + src
  if (/\/union\//.test(url)) return '/union' + src
  if (/\/extreme_host\//.test(url)) return '/extreme_host' + src
  if (/\/laboratory\//.test(url)) return '/laboratory' + src

  return src
}

/**
    获取url的全路径用于，window.open新开状况
    @method getFullUrl
    @param url 相对、全路径，根路径
    @return url 全路径

  var url="http://www.w3school.com.cn/tiy/t.asp?f=jseg_string";=》
  var url="/tiy/t.asp?f=jseg_string";=》http://www.w3school.com.cn/tiy/t.asp?f=jseg_string
  var url="tiy/t.asp?f=jseg_string"; =》http://www.w3school.com.cn/tiy/tiy/t.asp?f=jseg_string
*/
export function getFullUrl(url) {
  if (url.indexOf('http://') > -1 || url.indexOf('https://') > -1) {
    return url
  }
  if (url.indexOf('/') == 0) {
    return window.location.protocol + '//' + window.location.host + url
  } else {
    var temp = window.location.protocol + '//' + window.location.host + window.location.pathname
    return temp.substring(0, temp.lastIndexOf('/')) + '/' + url
  }
}

/**
    获取请求url后面的参数。
    @method getRequestParamter
    @param

    @return {object} 参数键值对
*/
export function getRequestParamter(urlStr, symbol = '#') {
  // var url = location.search; //获取url中"?"符后的字串
  var url = ''
  if (urlStr) {
    url = urlStr
  } else {
    url = window.location.href //获取url中"?"符后的字串
  }
  url = url.substr(url.indexOf('?'))

  var theRequest = new Object()
  if (url.indexOf('?') != -1) {
    let str = url.substr(1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      var tmp = strs[i].split('=') //a=b#123
      var tmpValue = tmp[1]
      if (tmpValue && tmpValue.indexOf('#') && symbol == '#') {
        tmpValue = tmpValue.split('#')[0]
      }
      theRequest[tmp[0]] = tmpValue
    }
  }
  return theRequest
}
